const initialeState = {
   filterChoiceState: "com",
};

const FilterToolsReducer = (state = initialeState, action) => {
   switch (action.type) {
      case "CHANGE_FILTER_CHOICE":
         return {
            ...state,
            filterChoiceState: action.data,
         };

      default:
         return state;
   }
};

export default FilterToolsReducer;
